// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import { isMobileOnly } from 'react-device-detect';
import AllowanceCreationComponent from '../../components/allowances/allowance-creation/allowance-creation';
import AllowanceDetailComponent from '../../components/allowances/allowance-detail/allowance-detail';
import AllowanceHistoryComponent from '../../components/allowances/allowance-history/allowance-history';
import AllowanceExpenseSubmissionComponent from '../../components/allowances/allowance-expense-submission/allowance-expense-submission';

// Primereact imports
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';

// Redux
import { connect } from 'react-redux';
import { getAllowanceList, getAllowancePresenceTicketMeetings } from '../../redux/actions/allowance';
import AllowanceService from '../../redux/services/allowance';
import { getAssociateData } from '../../redux/actions/profile';

// Utils
import { ALLOWANCE_APPROVED, ALLOWANCE_PAYED, ALLOWANCE_TYPE_MEAL_TRAVEL, ALLOWANCE_TYPE_PRESENCE_TICKET, ALLOWANCE_TYPE_REPRESENTATION, DECISION_APPROVAL, DECISION_WAIT_EXPENSE_SUBMISSION, DECISION_WAIT_PAYMENT, DIRECTION_APPROVAL, FINANCE_APPROVAL, ORGANIC_UNIT_APPROVAL } from '../../common/constants';
import { getPrettyDate } from '../../common/utils/date-utils';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './allowances.scss';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

class AllowanceListPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this._menu = React.createRef();
        this.state = {
            organicUnits: [],
            selectedAllowanceType: null,
            showAllowancesDialog: false,
            showAllowancesDetailDialog: false,
            showAllowancesHistoryDialog: false,
            showAllowancesExpenseSubmissionDialog: false,
            selectedAllowance: null,
            selectedDecisions: [],
            presenceTicketTypes: [],
            allowanceCreationMode: true
        };
    }

    componentDidMount() {
        this.props.getAllowanceList(this.props.associate.associateId);

        let organicUnits = [];

        for (let i = 0; i < this.props.organicUnits.length; i++) {
            organicUnits.push(this.props.organicUnits[i].id);            
        }

        this.props.getAllowancePresenceTicketMeetings(this.props.associate.associateId, organicUnits);

        this.setState({
            organicUnits: organicUnits
        });

        AllowanceService.getCurrentPresenceTicketTypePrices().then((response) => { 
            this.setState({
                presenceTicketTypes: response.presenceTicketTypes
            });
        })
        .catch(error => {
            console.error(error);
        });
    }

    showAllowancesDialog(allowanceType, creationMode, selectedAllowance) {
        this.setState({
            allowanceCreationMode: creationMode,
            showAllowancesDialog: true,
            selectedAllowanceType: allowanceType,
            selectedAllowance: selectedAllowance
        });
    }

    hideAllowancesDialog() {
        this.setState({
            showAllowancesDialog: false,
            dialogActiveIndex: 0
            // TODO: clear form
        });
    }

    updateDialogActiveIndex(dialogIndex) {
        this.setState({
            dialogActiveIndex: dialogIndex
        });
    }

    showAllowancesDetailDialog(selectedAllowance) {
        this.setState({
            showAllowancesDetailDialog: true,
            selectedAllowance: selectedAllowance,
            selectedAllowanceType: selectedAllowance.allowanceTypeId,
        });
    }

    showHistoryDetailDialog(selectedAllowance) {
        AllowanceService.getAllowanceDecisionFlow({ allowanceRef: selectedAllowance.allowanceRef })
        .then((response) => { 
            this.setState({
                showAllowancesHistoryDialog: true,
                selectedAllowance: selectedAllowance,
                selectedDecisions: response.decisions,
                selectedAllowanceType: selectedAllowance.allowanceTypeId,
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("allowances.messages.error"), life: 3000 });
        });
        
    }

    showExpensesSubmissionDialog(selectedAllowance) {
        this.setState({
            showAllowancesExpenseSubmissionDialog: true,
            selectedAllowance: selectedAllowance,
            selectedAllowanceType: selectedAllowance.allowanceTypeId
        });
    }

    hideExpensesSubmissionDialog() {
        this.setState({
            showAllowancesExpenseSubmissionDialog: false,
            selectedAllowance: null,
            selectedAllowanceType: null
        });
    }

    hideAllowancesDetailDialog() {
        this.setState({
            showAllowancesDetailDialog: false,
            selectedAllowance: null,
            selectedAllowanceType: null
        });
    }

    hideHistoryDetailDialog() {
        this.setState({
            showAllowancesHistoryDialog: false,
            selectedDecisions: [],
            selectedAllowance: null,
            selectedAllowanceType: null
        });
    }

    getAllowanceDetailDialogTitle() {
        let title = "";

        if(this.state.selectedAllowanceType !== null) {
            switch (this.state.selectedAllowanceType) {
                case ALLOWANCE_TYPE_PRESENCE_TICKET:
                    title = this.props.t("allowances.dialog.common.allowance-types.presence-ticket");
                    break;
                case ALLOWANCE_TYPE_MEAL_TRAVEL:
                    title = this.props.t("allowances.dialog.common.allowance-types.meal-hotel-travel");
                    break;
                case ALLOWANCE_TYPE_REPRESENTATION:
                    title = this.props.t("allowances.dialog.common.allowance-types.representation");
                    break;
                default:
                    break;
            }
        }

        return title;
    }

    dateBodyTemplate(rowData, column) {
        if(rowData[column] !== null) {
          return rowData[column] !== undefined ? getPrettyDate(rowData[column]) : "";
        }
        else {
          return "";
        }
    }

    stateBodyTemplate(rowData) {
        if(rowData.allowanceStateId === ORGANIC_UNIT_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(rowData.allowanceStateId === FINANCE_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(rowData.allowanceStateId === DIRECTION_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(rowData.allowanceStateId === DECISION_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(rowData.allowanceStateId === ALLOWANCE_APPROVED){
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("allowances.form.approved")}</span>;
        }
        else if(rowData.allowanceStateId === ALLOWANCE_PAYED){
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("allowances.form.payed")}</span>;
        }
        else if(rowData.allowanceStateId === DECISION_WAIT_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#A1CDEFFF', color: '#000000'}}>{this.props.t("allowances.form.wait-payment")}</span>;
        }
        else if(rowData.allowanceStateId === DECISION_WAIT_EXPENSE_SUBMISSION) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-expense-submission")}</span>;
        }
        else {
          return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("allowances.form.not-approved")}</span>;
       }
    }

    actionsBodyTemplate(rowData) {
       
       /* if(rowData.allowanceStateId === ALLOWANCE_APPROVED) {
            return <><Button icon="pi pi-search" tooltip="Ver detalhes" iconPos="right" onClick={() => this.showAllowancesDetailDialog(rowData)} /><Button className='mgl-20' icon="pi pi-euro" tooltip="Carregar faturas" iconPos="right" /></>;
        }
        else {*/
          return <>
                <Button icon="pi pi-search" tooltip={this.props.t("allowances.form.details")} iconPos="right" onClick={() => this.showAllowancesDetailDialog(rowData)} />
                {
                    rowData.allowanceStateId === DECISION_WAIT_EXPENSE_SUBMISSION && rowData.allowanceTypeId === ALLOWANCE_TYPE_MEAL_TRAVEL && rowData.allowanceTravelMealHotel.updatedDecision ?
                        <Button className='ml-5' icon="pi pi-euro" tooltip={this.props.t("allowances.form.expenses")} iconPos="right" onClick={() => this.showExpensesSubmissionDialog(rowData)} />
                        : null
                }
                {
                    (rowData.allowanceStateId === ORGANIC_UNIT_APPROVAL || rowData.allowanceStateId === FINANCE_APPROVAL || rowData.allowanceStateId === DECISION_APPROVAL) && rowData.allowanceTypeId === ALLOWANCE_TYPE_MEAL_TRAVEL ?
                        <Button className='ml-5' icon="pi pi-pencil" tooltip={this.props.t("allowances.form.edit")} iconPos="right" onClick={() => this.showAllowancesDialog(ALLOWANCE_TYPE_MEAL_TRAVEL, false, rowData)} />
                        : null
                }
                <Button className='ml-5' icon="pi pi-history" tooltip={this.props.t("allowances.form.history")} iconPos="right" onClick={() => this.showHistoryDetailDialog(rowData)} />
            </>;
      // }
    }
    
    getSelectedAllowanceOrganicUnitDetails(organicUnitId) {
        let organicUnit = null;

        for (let i = 0; i < this.props.organicUnits.length; i++) {
            if(this.props.organicUnits[i].id === organicUnitId) {
                organicUnit = this.props.organicUnits[i];
            }
        }

        return organicUnit;
    }

    reloadAllowances() {
        // reload allowance list
        this.props.getAllowanceList(this.props.associate.associateId);

        // reload meeting list
        this.props.getAllowancePresenceTicketMeetings(this.props.associate.associateId, this.state.organicUnits);

        // reload associate data
        this.props.getAssociateData(this.props.registrationRef);

        // hide modal
        this.hideAllowancesDialog();
    }

    submitAllowanceExpenses() {
        // reload allowance list
        this.props.getAllowanceList(this.props.associate.associateId);

        // reload associate data
        this.props.getAssociateData(this.props.registrationRef);
        
        this.setState({ showAllowancesExpenseSubmissionDialog: false }); 

        this._toast.current.show({ severity: 'success', detail: this.props.t("allowances.dialog.expenses.success"), life: 5000 });
    }

    render() {  

        let items = [];

        let hasMealTravelHotel = false;
        let hasPresenceTicket = false;
        
        if(this.props.externalRepresentation) {
            /*items.push({
                label: this.props.t("allowances.form.representation"),
                icon: 'pi pi-car',
                command: () => {
                    this.showAllowancesDialog(ALLOWANCE_TYPE_REPRESENTATION, true, null);
                }
            });*/
        }
        else {
            if (this.props.organicUnits.length > 0) {
                for (let i = 0; i < this.props.organicUnits.length; i++) {
                    if(this.props.organicUnits[i].allowTravelHotelRequests) {
                        hasMealTravelHotel = true;
                    }

                    if(this.props.organicUnits[i].presenceTicketType !== null) {
                        hasPresenceTicket = true;
                    }
                }
            }

            if(hasMealTravelHotel) {
                items.push({
                    label: this.props.t("allowances.form.meal-hotel-travel"),
                    icon: 'pi pi-car',
                    command: () => {
                        this.showAllowancesDialog(ALLOWANCE_TYPE_MEAL_TRAVEL, true, null);
                    }
                });
            }

            if(hasPresenceTicket) {
                items.push({
                    label: this.props.t("allowances.form.presence-ticket"),
                    icon: 'pi pi-briefcase',
                    command: () => {
                        this.showAllowancesDialog(ALLOWANCE_TYPE_PRESENCE_TICKET, true, null);
                    }
                });
            }

            /*items.push({
                label: this.props.t("allowances.form.representation"),
                icon: 'pi pi-car',
                command: () => {
                    this.showAllowancesDialog(ALLOWANCE_TYPE_REPRESENTATION, true, null);
                }
            });*/
        }
        

        return (
            <div>
                <PageTitleComponent title={this.props.t("allowances.title")} />
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10">
                        <div id="data-container" className="card mgt-20">
                        {
                            this.props.allowances !== null ? 
                            <div className="grid">
                                <div className="col-12 t-align-right">
                                    <Menu style={{width:"300px"}} model={items} popup ref={this._menu} />
                                    <Button label={this.props.t("allowances.form.new-allowance")} icon="pi pi-plus" onClick={(e) => this._menu.current.toggle(e)} />
                                </div>   
                                <div className="col-12">
                                    <DataTable value={this.props.allowances} className="p-datatable-gridlines" showGridlines rows={12} dataKey="allowanceRef" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-allowances")}>
                                        <Column field="allowanceRef" header={this.props.t("allowances.form.reference-header")} style={{ minWidth: '10rem' }}  />
                                        <Column field="allowanceType" header={this.props.t("allowances.form.type-header")} style={{ minWidth: '10rem' }}  />
                                        <Column field="eventPlace" header={this.props.t("allowances.form.event-place-header")} style={{ minWidth: '10rem' }}  />
                                        <Column field="eventBeginDate" header={this.props.t("allowances.form.event-begin-date-header")} body={(data) => this.dateBodyTemplate(data, 'eventBeginDate')} style={{ minWidth: '12rem' }} />
                                        <Column field="eventEndDate" header={this.props.t("allowances.form.event-end-date-header")}body={(data) => this.dateBodyTemplate(data, 'eventEndDate')} style={{ minWidth: '12rem' }}  />
                                        <Column field="allowanceStateId" header={this.props.t("allowances.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '12rem' }} />
                                        <Column field="allowanceRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data)} style={{ minWidth: '12rem' }} />
                                    </DataTable>
                                </div>   
                            </div>
                            : null
                        }
                        </div>
                    </div>
                    <div className='col-1'></div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
                <Dialog visible={this.state.showAllowancesDetailDialog} style={{ width: '850px' }} header={this.getAllowanceDetailDialogTitle()} modal onHide={() => this.hideAllowancesDetailDialog() }>
                    <AllowanceDetailComponent allowance={this.state.selectedAllowance} organicUnit={this.state.selectedAllowance ? this.getSelectedAllowanceOrganicUnitDetails(this.state.selectedAllowance.organicUnitId) : null} associate={this.props.associate} ballot={this.props.ballot} />
                </Dialog>
                <Dialog visible={this.state.showAllowancesHistoryDialog} style={{ width: '850px' }} header={this.getAllowanceDetailDialogTitle()} modal onHide={() => this.hideHistoryDetailDialog() }>
                    <AllowanceHistoryComponent allowance={this.state.selectedAllowance} decisions={this.state.selectedDecisions} />
                </Dialog>
                <Dialog visible={this.state.showAllowancesExpenseSubmissionDialog} style={{ width: '950px' }} header={this.getAllowanceDetailDialogTitle()} modal onHide={() => this.hideExpensesSubmissionDialog() }>
                    <AllowanceExpenseSubmissionComponent allowance={this.state.selectedAllowance} onClose={() => { this.submitAllowanceExpenses() }} />
                </Dialog>
                <Dialog visible={this.state.showAllowancesDialog} style={{ width: '850px' }} header={this.props.t("allowances.dialog.title") + this.getAllowanceDetailDialogTitle()} modal onHide={() => this.hideAllowancesDialog() }>
                    <AllowanceCreationComponent creationMode={this.state.allowanceCreationMode} selectedAllowance={this.state.selectedAllowance} allowances={this.props.allowances} organicUnits={this.props.organicUnits} meetings={this.props.meetings} presenceTicketTypes={this.state.presenceTicketTypes} associate={this.props.associate} ballot={this.props.ballot} selectedAllowanceType={this.state.selectedAllowanceType} onClose={() => this.reloadAllowances()} />
                </Dialog>
            </div>
        );
  }
}   

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        ballot: state.profile.ballot,
        allowances: state.allowance.allowances,
        meetings: state.allowance.meetings,
        organicUnits: state.authentication.organicUnits,
        externalRepresentation: state.authentication.externalRepresentation
    } 
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        getAllowanceList: (associateId) => { dispatch(getAllowanceList(associateId)) },
        getAllowancePresenceTicketMeetings: (associateId, organicUnits) => { dispatch(getAllowancePresenceTicketMeetings(associateId, organicUnits)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
  };

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(AllowanceListPage)));